import {
  addItemToNextBox,
  createFromItem,
  getOGCustomer,
  getOGUpcomingOrders,
  getOGOrder,
  sortOGOrders,
} from '../subscription-modal/ordergroove-api-helper';

export default () => ({
    initialized: false,
    init() {
        if (this.initialized) return;
        this.initialized = true;
        initializeOGAuth();
    },
});

// fireDlAddToNextBoxEvent function removed - using window.dsc.fireDlAddToNextBoxEvent directly instead

async function toggleInNextBoxMessageText(nextOrder) {
    // get info for the next order date
    const addToNextBoxButton = document.querySelector('.add-to-next-box-custom');
    const offer = addToNextBoxButton.getAttribute('data-offer-id'); // default to 1 month for release
    const ogNextOrder = await getOGOrder(nextOrder.public_id)
    const productsInNextOrder = ogNextOrder.results.reduce(
        (result, { product, offer }) => {
        result[product] = offer
        return result
        },
        {},
    )
    const productId = addToNextBoxButton.getAttribute('data-variant-id');
    const productInNextBoxMessage = document.querySelector('.in-next-box-message')
    const productInNextBoxMessageText = document.querySelector(
        '.in-next-box-message-text',
    )
    const loadingSpinner = document.querySelector('.loading__spinner');

    const userLocale = new Intl.NumberFormat().resolvedOptions().locale
    const nextOrderDate = new Date(nextOrder.place).toLocaleDateString(
        userLocale,
        { month: 'short', day: 'numeric' },
    )
    productInNextBoxMessageText.innerHTML = productInNextBoxMessageText.innerHTML.replace('{date}', `${nextOrderDate}`)
    loadingSpinner.classList.add('hidden')

    // check if product is in next order
    // show message if product is in next order
    if (productsInNextOrder[productId] && productsInNextOrder[productId] === offer) {
        productInNextBoxMessage.classList.remove('hidden')
        addToNextBoxButton.classList.add('hidden')
        return true
    } else {
        productInNextBoxMessage.classList.add('hidden')
        addToNextBoxButton.classList.remove('hidden');
        return false
    }
}

async function initializeOGAuth() {
    await window.dsc?.ensureSubscriberHydrated?.();

    const ogCustomer = await getOGCustomer(window?.dsc?.customerId);
    const ogUpcomingOrders = await getOGUpcomingOrders(window?.dsc?.customerId);

    if (ogUpcomingOrders && ogUpcomingOrders.results.length) {
        sortOGOrders(ogUpcomingOrders.results);
    }

    const isUserWithSubscription = ogCustomer && ogUpcomingOrders.count > 0;
    const addToNextBoxButton = document.querySelector('.add-to-next-box-custom');

    if (isUserWithSubscription) {
        if (ogUpcomingOrders && ogUpcomingOrders.results.length) {
            await toggleInNextBoxMessageText(ogUpcomingOrders.results[0]);
        }

        addToNextBoxButton.addEventListener('click', async (e) => {
          e.preventDefault();
          addToNextBoxButton.setAttribute('disabled', 'disabled');
          const orderId = ogUpcomingOrders.results[0].public_id;
          const productId = addToNextBoxButton.getAttribute('data-variant-id');
          const subscriptionFrequency = addToNextBoxButton.getAttribute('data-sub-frequency'); // default to 1 month for release
          const offer = addToNextBoxButton.getAttribute('data-offer-id'); // default to 1 month for release
          const quantity = 1;
          const response = await addItemToNextBox({
              order: orderId,
              product: productId,
              quantity: quantity,
              offer,
          });
          await createFromItem({
            item: response.public_id,
            every: subscriptionFrequency,
            offer,
          });
        
          const addButtonData = {
            product_id: addToNextBoxButton.getAttribute('data-product-id'),
            product_name: addToNextBoxButton.getAttribute('data-product-name'),
            product_category: addToNextBoxButton.getAttribute('data-product-category'),
            sku: addToNextBoxButton.getAttribute('data-sku'),
            variant_name: addToNextBoxButton.getAttribute('data-variant-name'),
            variant_id: addToNextBoxButton.getAttribute('data-variant-id'),
            sub_frequency: addToNextBoxButton.getAttribute('data-sub-frequency'),
            selling_plan_id: addToNextBoxButton.getAttribute('data-selling-plan-id'),
            offer_id: addToNextBoxButton.getAttribute('data-offer-id'),
            price: addToNextBoxButton.getAttribute('data-product-price'),
            quantity: quantity,
          };
          if (window.dsc && typeof window.dsc.fireDlAddToNextBoxEvent === 'function') {
            const isSubscription = addButtonData.sub_frequency !== '' && addButtonData.sub_frequency !== null;
            const addType = isSubscription ? 'subscribe' : 'add-one-time-to-next-box';

            window.dsc.fireDlAddToNextBoxEvent(
              addType,
              addButtonData.variant_id,
              addButtonData.sku,
              quantity,
              isSubscription ? addButtonData.selling_plan_id : null
            );
          }
          toggleInNextBoxMessageText(ogUpcomingOrders.results[0]);

          e.stopPropagation();
        });
    }
}
